import { GET_PERSONS } from '../actionTypes'
import { Person } from '../reducers/clients'


export const getPersonsAction = (persons: Person[]) => ({ type: GET_PERSONS, payload: persons })
